import { inject, Injectable } from '@angular/core';
import { asNonUndefined, WINDOW } from '@kaseya-utils';
import { adaNewMessageEventName, AdaWindow } from '@core/ada/models/ada-window.interface';
import { AdaFacade } from '@core/ada/facades/ada.facade';
import { catchError, EMPTY, from } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AdaEventsFacade {
  private readonly window = inject<AdaWindow>(WINDOW);
  private readonly adaFacade = inject(AdaFacade);

  private subscriptionIds: number[] = [];

  subscribeToAdaEvents(): void {
    if (!this.window.adaEmbed) {
      return;
    }

    this.unsubscribeFromAdaEvents();
    this.subscribeToEvent(adaNewMessageEventName, () => this.adaFacade.markMessagesAsUnread());
  }

  unsubscribeFromAdaEvents(): void {
    if (!this.window.adaEmbed || !this.subscriptionIds.length) {
      return;
    }

    const adaEmbed = asNonUndefined(this.window.adaEmbed);
    this.subscriptionIds.forEach(subscriptionId => adaEmbed.unsubscribeEvent(subscriptionId));
    this.subscriptionIds = [];
  }

  private subscribeToEvent(eventName: string, handler: () => void): void {
    from(asNonUndefined(this.window.adaEmbed).subscribeEvent(eventName, handler))
      .pipe(
        catchError((error: unknown) => {
          const originalMessage = error instanceof Error ? error.message : `${error}`;
          console.error(`Failed to subscribe to Ada event: ${originalMessage}`);

          return EMPTY;
        })
      )
      .subscribe(subscriptionId => this.subscriptionIds.push(subscriptionId));
  }
}
